
$(document).ready(function(){

    var pipActive = false;

    $('.pin').click(function(){
        activatePin($(this));
        $('.pip-overlay').fadeIn(1000);
    });

    $('.pin').hover(function(){

        var targetShade = $(this).attr('target-shade');
        $('.shade[id='+targetShade+']').stop(true, true).fadeIn();
        $('.shade-overlay').stop(true, true).fadeIn();
    }, function(){
        if (pipActive == false){
            var targetShade = $(this).attr('target-shade');
            $('.shade[id='+targetShade+']').stop(true, true).fadeOut();
            $('.shade-overlay').stop(true, true).fadeOut();
        }
    });

    $('.pip-overlay').click(function(){
        var targetShade = $(this).attr('target-shade');
        $('.shade[id='+targetShade+']').stop(true, true).fadeIn();
        $('.shade-overlay').stop(true, true).fadeIn();
        deactivatePins();
    });

    function activatePin(pin){
        pin.addClass('active');
        pipActive = true;
        $('.pin-interactive').addClass('pip-is-active');
    }

    function deactivatePins(){
        $('.pip-overlay').fadeOut(750);
        $('.pin').delay(750).removeClass('active');
        $('.shade').stop(true, true).fadeOut();
        $('.shade-overlay').stop(true, true).fadeOut();
        $('.pin-interactive').removeClass('pip-is-active');
        pipActive = false;
    }
});